import "./index.css";
import { useEffect, useContext, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DashboardCounter from "../../components/DashboardCounter/index";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import PageLayout from "../../layouts/PageLayout";
import Ico1 from "../../assets/img/edit.png";
import Ico2 from "../../assets/img/delete.png";
import Ico3 from "../../assets/img/s.png";
import Ico4 from "../../assets/img/d.png";
import Clap from "../../assets/img/clap.png";
import Diconetwo from "../../assets/img/real_time.svg";
import Diconethree from "../../assets/img/active_daily_mgmt.svg";
import Iconone from "../../assets/img/beds.png";
import Icontwo from "../../assets/img/compliance.png";
import Iconthree from "../../assets/img/variance.png";
import Iconfour from "../../assets/img/hpuoc.png";
import Ico22 from "../../assets/img/info.png";
import Ico33 from "../../assets/img/warning.png";
import Ico44 from "../../assets/img/critical.png";
import More from "../../assets/img/ui.png";
import { get } from "lodash";
import { API_CALL_URL_PRIVATE } from "../../constants";
import axios from "../../axios";
import { DOMAIN_URL } from "../../constants/compensate";
import ReactPaginate from "react-paginate";
import { setLoadingPage } from "../../store/actions";
import { Switch } from "antd";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { flushSync } from "react-dom";
// import { useSelector } from "react-redux";
import AscIcon from "../../assets/img/desc.png";
import DescIcon from "../../assets/img/asc.png";
import moment from "moment";

function PayPeriod(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("psAdmin"));
  const customer_code = useSelector((state) => state.compensate.customerCode);
  const loading_page = useSelector((state) => state.compensate.LoadingPage);
  console.log(loading_page, "loading");
  const [dashboardData, setDashboardData] = useState([]);
  const [customerData, setCustomerData] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [pageLimit, setPageLimit] = useState(50);
  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [hasPrev, setHasPrev] = useState(false);
  const [hasNext, setHasNext] = useState(false);
  const [sortKey, setSortKey] = useState("");
  const [isInitialData, setISInitialData] = useState(false);
  const [sortOrder, setSortOrder] = useState(1);
  const boxdata = props.data;
  const isLoader = props.isLoader;
  const { issearch } = props;
  const [userDatas, setUserDatas] = useState(get(userData, "data", []));
  const [pageCounter, setPageCounter] = useState("");
  const [searchTempKeyword, setSearchTempKeyword] = useState("");
  const [isStatusDrop, setIsStatusDrop] = useState(false);
  const [statusUpdate, setStatusUpdate] = useState(false);
  const [listLoader, setListLoader] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [expandedComments, setExpandedComments] = useState({});

  // function getDate(inputDate) {
  //   const timeZone = "America/Los_Angeles";
  //   const date = new Date(
  //     new Date(inputDate).toLocaleString("en-US", { timeZone })
  //   );
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
  //   const year = date.getFullYear();
  //   const hours = String(date.getHours()).padStart(2, "0"); // 24-hour format
  //   const minutes = String(date.getMinutes()).padStart(2, "0");
  //   return `${month}/${day}/${year}, ${hours}:${minutes}`;
  // }
  function getDate(inputDate) {
    const timeZone = "America/Los_Angeles";
    const date = new Date(inputDate).toLocaleString("en-US", {
      timeZone,
      hour12: true,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });

    return date;
  }

  function convertDateFormat(inputDate) {
    // Check if inputDate is provided and not empty
    if (!inputDate) return "";

    // Split the date string by "-"
    const parts = inputDate.split("-");
    if (parts.length !== 3) return ""; // Return empty string if the format is incorrect

    // Rearrange the parts from "dd-mm-yyyy" to "mm-dd-yyyy"
    const [day, month, year] = parts;
    return `${month}/${day}/${year}`;
  }

  const handleSwitchChange = (status, id) => {
    document.body.style.overflow = "hidden";
    Swal.fire({
      title: "Confirmation",
      text: `Are you sure you want to ${
        status ? "Active" : "Inactive"
      } the status?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        statusUpdateApi(status, id);
      }
    });
  };
  const statusUpdateApi = async (val, id) => {
    try {
      const resp = await axios.put(
        `${API_CALL_URL_PRIVATE}/setting/update/${id}`,
        {
          status: parseInt(val),
        }
      );
      console.log(resp);
      toast.success(resp?.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });
      setStatusUpdate(!statusUpdate);
    } catch (error) {
      toast.error("Something went wrong..! Try Again", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });

      console.log(error);
    }
  };

  const renderElements = () => {
    return Array.from({ length: totalPages }, (_, index) => (
      <span
        key={index + 1}
        className={
          index + 1 === currentPage
            ? "paginate_button current"
            : "paginate_button"
        }
        aria-controls="example"
        role="link"
        aria-current="page"
        data-dt-idx="0"
        tabindex="0"
        onClick={() => {
          setCurrentPage(index + 1);
        }}
      >
        {index + 1}
      </span>
    ));
  };

  useEffect(() => {
    const getActivityDetailList = async () => {
      try {
        const resp = await axios.get(
          `${API_CALL_URL_PRIVATE}/setting?customer_code=${encodeURIComponent(
            customer_code
          )}&searchKeyword=${encodeURIComponent(
            searchKeyword
          )}&sort_column=${encodeURIComponent(
            searchActive ? "" : sortKey
          )}&sort_order=${encodeURIComponent(
            searchActive ? -1 : sortOrder
          )}&limit=${encodeURIComponent(pageLimit)}&page=${encodeURIComponent(
            searchActive ? 1 : currentPage
          )}`
        );
        console.log(resp);

        const Data = resp?.data?.data?.data;
        console.log(Data);
        setSearchActive(false);
        setCustomerData(Data);
        setPageLimit(Data.limit ? Data.limit : 50);
        setTotalPages(Data?.totalPages);
        setCurrentPage(Data.page ? Data.page : 1);
        setHasNext(Data?.hasNextPage);
        setHasPrev(Data?.hasPrevPage);
        setPageCounter(Data?.pagingCounter);
        setListLoader(false);
        setISInitialData(true);
        dispatch(setLoadingPage(false));
      } catch (error) {
        console.log(error);
      }
    };

    getActivityDetailList();
  }, [
    searchKeyword,
    pageLimit,
    currentPage,
    sortOrder,
    customer_code,
    sortKey,
    statusUpdate,
  ]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected + 1);
    setListLoader(true);
  };
  const renderSortIcon = (key) => {
    if (sortKey !== key) return <img src={DescIcon} alt="Descending" />;
    return sortOrder === -1 ? (
      <img src={DescIcon} alt="Descending" />
    ) : sortOrder === 1 ? (
      <img src={AscIcon} alt="Ascending" />
    ) : null;
  };
  const handleSort = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === -1 ? 1 : -1);
      setCurrentPage(1);
      setListLoader(true);
    } else {
      setSortKey(key);
      setSortOrder(1);
      setCurrentPage(1);
      setListLoader(true);
    }
  };

    const toggleComment = (index) => {
      setExpandedComments((prevState) => ({
        ...prevState,
        [index]: !prevState[index],
      }));
    };

    const formatDateToDDMMYYYY = (dateString) => {
      return moment(dateString, "DD-MM-YYYY")?.format("MM/DD/YYYY");
    };


  return (
    <>
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="page-header">
            <h3 className="page-title">
              <a href="#" className="badge badge-dark"></a>
            </h3>
            <div className></div>
          </div>
          <div className="row">
            <div className="col-lg-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between mb-4">
                    <h4 className="card-title">Settings</h4>

                    <Link className="boxlink" to="/admin/settings/add-settings">
                      {" "}
                      <button type="button" class="btn btn-success">
                        Add Settings
                      </button>
                    </Link>
                  </div>
                  <div className="d-flex justify-content-between mobile-wrap">
                    <div class="dataTables_length" id="example_length">
                      <label>
                        Show &nbsp;
                        <select
                          name="example_length"
                          aria-controls="example"
                          class=""
                          value={pageLimit}
                          onChange={(e) => {
                            setPageLimit(e.target.value);
                            setListLoader(true);
                          }}
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>{" "}
                        &nbsp;entries
                      </label>
                    </div>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault(); // Prevent the default form submission behavior
                        if (searchKeyword !== searchTempKeyword) {
                          flushSync(() => {
                            setSearchActive(true);
                            setSortKey("");
                          });
                          setListLoader(true);
                          setSearchKeyword(searchTempKeyword);
                        }
                      }}
                    >
                      <div
                        id="example_filter"
                        class="dataTables_filter d-flex align-items-center justify-content-center "
                      >
                        <label>
                          Search: &nbsp;
                          <input
                            type="text"
                            class=""
                            placeholder=""
                            aria-controls="example"
                            onChange={(e) => {
                              setSearchTempKeyword(e.target.value);
                              if (e.target.value === "") {
                                setListLoader(true);
                                setSearchKeyword("");
                              }
                            }}
                            // onKeyDown={(e) => {
                            //   if (e.key === "Enter") {
                            //     setSearchKeyword(e.target.value);
                            //   }
                            // }}
                          />
                        </label>

                        <div
                          style={{
                            border: "1px solid #aaa",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "9px",
                            marginBottom: "7px",
                            cursor: "pointer",
                            marginTop: "-1px",
                            marginLeft: "-1px",
                          }}
                          onClick={() => {
                            if (searchKeyword !== searchTempKeyword) {
                              flushSync(() => {
                                setSearchActive(true);
                                setSortKey("");
                              });
                              setListLoader(true);
                              setSearchKeyword(searchTempKeyword);
                            }
                          }}
                        >
                          <i class="ph ph-magnifying-glass"></i>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div>
                    <div className="table-responsive">
                      <table className="table filter-table">
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th
                              onClick={() => {
                                handleSort("key");
                              }}
                            >
                              Title
                              <span className="ms-1 bright">
                                {renderSortIcon("key")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("value");
                              }}
                            >
                              Message
                              <span className="ms-1 bright">
                                {renderSortIcon("value")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("status");
                              }}
                            >
                              Status
                              <span className="ms-1 bright">
                                {renderSortIcon("status")}
                              </span>
                            </th>

                            <th
                              onClick={() => {
                                handleSort("customer_code");
                              }}
                            >
                              Customer Code
                              <span className="ms-1 bright">
                                {renderSortIcon("customer_code")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("start_date");
                              }}
                            >
                              Start Date
                              <span className="ms-1 bright">
                                {renderSortIcon("start_date")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("end_date");
                              }}
                            >
                              End Date
                              <span className="ms-1 bright">
                                {renderSortIcon("end_date")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("updatedAt");
                              }}
                            >
                              Updated At
                              <span className="ms-1 bright">
                                {renderSortIcon("updatedAt")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("createdAt");
                              }}
                            >
                              Created At
                              <span className="ms-1 bright">
                                {renderSortIcon("createdAt")}
                              </span>
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        {isInitialData && !loading_page && !listLoader ? (
                          <>
                            {customerData?.docs?.length > 0 ? (
                              <tbody>
                                {customerData?.docs?.map((Ele, ind) => {
                                  const isExpanded = expandedComments[ind];
                                  const truncatedComment = Ele?.value.substring(
                                    0,
                                    45
                                  );
                                  const displayComment = isExpanded
                                    ? Ele?.value
                                    : truncatedComment;
                                  return (
                                    <tr key={Ele._id}>
                                      <td>{ind + pageCounter}</td>
                                      <td>{Ele?.key}</td>
                                      <td>
                                        {" "}
                                        {displayComment}
                                        {Ele?.value.length > 45 && (
                                          <span
                                            className="shwmore"
                                            onClick={() => toggleComment(ind)}
                                          >
                                            {isExpanded ? (
                                              "Less"
                                            ) : (
                                              <img
                                                src={More}
                                                width={18}
                                                title="Read More"
                                              />
                                            )}
                                          </span>
                                        )}
                                      </td>

                                      <td className="statusTD">
                                        <Switch
                                          checked={Ele?.status}
                                          onChange={() => {
                                            handleSwitchChange(
                                              Ele?.status === 1 ? 0 : 1,
                                              Ele?._id
                                            );
                                          }}
                                          checkedChildren="Active"
                                          unCheckedChildren="Inactive"
                                        />
                                      </td>
                                      <td>{Ele?.customer_code ?? "N/A"}</td>
                                      <td>
                                        {formatDateToDDMMYYYY(Ele?.start_date)}
                                        {Ele?.start_time ? ", " : ""}
                                        {Ele?.start_time
                                          ? moment(
                                              Ele?.start_time,
                                              "HH:mm:ss"
                                            ).format("hh:mm A")
                                          : ""}
                                      </td>
                                      <td>
                                        {formatDateToDDMMYYYY(Ele?.end_date)}
                                        {Ele?.end_time ? ", " : ""}
                                        {Ele?.end_time ? moment(
                                          Ele?.end_time,
                                          "HH:mm:ss"
                                        ).format("hh:mm A") : ""}
                                      </td>
                                      <td>{getDate(Ele?.updatedAt)}</td>
                                      <td>{getDate(Ele?.createdAt)}</td>

                                      <td>
                                        <label className="edit">
                                          <Link
                                            className="boxlink"
                                            to={`/admin/settings/edit-settings/${Ele?._id}`}
                                          >
                                            <img
                                              src={Ico1}
                                              className="w-a"
                                              alt="icon"
                                            />
                                          </Link>
                                        </label>
                                        {/* {" "}
                               &nbsp;
                               <label className="edit">
                                 <img src={Ico2} className="w-a" />
                               </label> */}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            ) : (
                              <tbody>
                                <tr>
                                  <td colSpan="10">
                                    <div
                                      className="d-flex justify-content-center align-items-center"
                                      style={{ height: "200px" }}
                                    >
                                      <p class="text-secondary display-6">
                                        Oops! Data Not found
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            )}
                          </>
                        ) : (
                          <>
                            <tbody>
                              <tr>
                                <td colSpan="10">
                                  <div
                                    className="d-flex align-items-center justify-content-center w-100"
                                    style={{ height: "400px" }}
                                  >
                                    <span
                                      class="loader"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                      }}
                                    ></span>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </>
                        )}
                      </table>
                    </div>
                    {isInitialData && !loading_page && !listLoader ? (
                      <>
                        <div className="d-flex justify-content-between">
                          <div
                            class="dataTables_info"
                            id="example_info"
                            role="status"
                            aria-live="polite"
                          >
                            Showing {pageCounter} to{" "}
                            {Math.min(
                              pageCounter + pageLimit - 1,
                              customerData.totalDocs
                            )}{" "}
                            of total {customerData?.totalDocs} entries
                          </div>
                          <div
                            class="dataTables_paginate paging_simple_numbers"
                            id="example_paginate"
                          >
                            {/* {hasPrev && (
                      <span
                        className="paginate_button previous disabled"
                        aria-controls="example"
                        aria-disabled="true"
                        role="link"
                        data-dt-idx="previous"
                        tabindex="-1"
                        id="example_previous"
                        onClick={() => {
                          setCurrentPage(customerData?.prevPage);
                        }}
                      >
                        Previous
                      </span>
                    )}
                    <span>
                      {renderElements()}
                    </span>
                    {hasNext && (
                      <span
                        className="paginate_button next"
                        aria-controls="example"
                        role="link"
                        data-dt-idx="next"
                        tabindex="0"
                        id="example_next"
                        onClick={() => {
                          setCurrentPage(customerData?.nextPage);
                        }}
                      >
                        Next
                      </span>
                    )} */}
                            <span>
                              <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                breakLabel={"..."}
                                pageCount={customerData?.totalPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination"}
                                previousLinkClassName={"paginationLink"}
                                nextLinkClassName={"paginationLink"}
                                disabledClassName={"paginationDisabled"}
                                activeClassName={"paginationActive"}
                                forcePage={currentPage - 1}
                              />
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PayPeriod;
